"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = load;
exports.load1 = load1;
exports.checkSubscription = checkSubscription;

require("regenerator-runtime/runtime");

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getConfig = function getConfig() {
  try {
    var configs = require("../../../../../config.json");

    return configs;
  } catch (ex) {
    throw "config.json not found";
  }
};

function loadOnce(_x, _x2, _x3, _x4, _x5, _x6) {
  return _loadOnce.apply(this, arguments);
}

function _loadOnce() {
  _loadOnce = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(window, maybeConfig, operator, keyword, shortcode, strategy) {
    var _keyword, _shortcode, offer, config, host, country, slug, rockmanId, isDMB, newHost, search, result;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!!maybeConfig && maybeConfig.tag == "keywordAndShortCode")) {
              _context2.next = 5;
              break;
            }

            _keyword = maybeConfig.keyword, _shortcode = maybeConfig.shortcode;
            return _context2.abrupt("return", _objectSpread({
              type: "SingleSubmissionResult"
            }, {
              keyword: _keyword,
              shortcode: _shortcode
            }));

          case 5:
            offer = window.pac_analytics.visitor.offer;
            config = strategy ? _objectSpread({
              offer: window.pac_analytics.visitor.offer
            }, strategy.flowConfig) : _objectSpread({}, getConfig(), maybeConfig || {});
            host = config.host, country = config.country, slug = config.slug;
            rockmanId = window.pac_analytics.visitor.rockmanId;
            isDMB = window.pac_analytics.visitor.xaid != null && window.pac_analytics.visitor.xaid.toLowerCase().indexOf("dmb") != -1 ? true : false;
            newHost = isDMB ? "de.tallymans.com" : host;
            search = window.location.search.substr(1) || '';
            _context2.next = 14;
            return fetch("https://".concat(newHost, "/tallyman/v1/?action=oc2sms&country=").concat(country, "&slug=").concat(slug, "&offerId=").concat(offer).concat(!!keyword ? '&keyword=' + keyword : '', "&device=smart&rockman_id=").concat(rockmanId).concat(!!operator ? '&operator=' + operator : '', "&").concat(search)).then(function (x) {
              return x.json();
            });

          case 14:
            result = _context2.sent;

            if (result.success) {
              _context2.next = 19;
              break;
            }

            throw result.message;

          case 19:
            return _context2.abrupt("return", _objectSpread({
              type: "SingleSubmissionResult"
            }, {
              keyword: "".concat(keyword || result.displayKeyword).concat(!!result.uid ? ' ' + result.uid : ''),
              shortcode: result.shortcode
            }));

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadOnce.apply(this, arguments);
}

function right(r) {
  return {
    type: 'right',
    value: r
  };
}

function left(l) {
  return {
    type: 'left',
    value: l
  };
}

function foldEither(left, right, either) {
  return either.type == 'left' ? left(either.value) : right(either.value);
}

function loadForMultipleOperators(_x7, _x8, _x9, _x10, _x11, _x12) {
  return _loadForMultipleOperators.apply(this, arguments);
}

function _loadForMultipleOperators() {
  _loadForMultipleOperators = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(window, maybeConfig, operators, keyword, shortcode, strategy) {
    var results, finalResults, arrResult;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            results = Promise.all(operators.map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(o) {
                var singleResult;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return loadOnce(window, maybeConfig, o, keyword, shortcode, strategy);

                      case 3:
                        singleResult = _context3.sent;
                        return _context3.abrupt("return", right(_objectSpread({}, singleResult, {
                          operator: o
                        })));

                      case 7:
                        _context3.prev = 7;
                        _context3.t0 = _context3["catch"](0);
                        return _context3.abrupt("return", left(_context3.t0));

                      case 10:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[0, 7]]);
              }));

              return function (_x30) {
                return _ref2.apply(this, arguments);
              };
            }()));
            _context4.next = 3;
            return Promise.resolve(results);

          case 3:
            finalResults = _context4.sent;

            if (!finalResults.every(function (r) {
              return r.type == 'left';
            })) {
              _context4.next = 8;
              break;
            }

            throw finalResults[0].value;

          case 8:
            arrResult = [];
            finalResults.map(function (obj) {
              if (obj.type == 'right') {
                var _ref3 = obj.value,
                    _keyword2 = _ref3.keyword,
                    _shortcode2 = _ref3.shortcode,
                    operator = _ref3.operator;
                arrResult.push({
                  keyword: _keyword2,
                  shortcode: _shortcode2,
                  operator: operator
                });
              }
            });
            return _context4.abrupt("return", {
              type: "MultiOperatorSubmissionResult",
              data: arrResult
            });

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _loadForMultipleOperators.apply(this, arguments);
}

function load(_x13, _x14, _x15, _x16, _x17) {
  return _load.apply(this, arguments);
}

function _load() {
  _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(window, maybeConfig, keyword, shortcode, strategy) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(!!maybeConfig && maybeConfig.tag == "keywordAndShortCode")) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", _objectSpread({
              type: "SingleSubmissionResult"
            }, {
              keyword: maybeConfig.keyword,
              shortcode: maybeConfig.shortcode
            }));

          case 4:
            if (!(!!maybeConfig && maybeConfig.tag == "keyword")) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("return", load1(window, maybeConfig, keyword, shortcode, strategy));

          case 8:
            return _context5.abrupt("return", load1(window, maybeConfig, null, null, strategy));

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _load.apply(this, arguments);
}

function load1(_x18, _x19, _x20, _x21, _x22) {
  return _load2.apply(this, arguments);
}

function _load2() {
  _load2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(window, maybeConfig, keyword, shortcode, strategy) {
    var config;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            config = strategy ? _objectSpread({}, strategy.flowConfig) : _objectSpread({}, getConfig(), maybeConfig || {});

            if (!(true == config.automaticallySubmitAllOperators && !!config.operators && config.operators.length > 0)) {
              _context6.next = 5;
              break;
            }

            return _context6.abrupt("return", loadForMultipleOperators(window, maybeConfig, config.operators, keyword, shortcode, strategy));

          case 5:
            return _context6.abrupt("return", loadOnce(window, maybeConfig, null, keyword, shortcode, strategy));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _load2.apply(this, arguments);
}

var wait = function wait(ms) {
  return new Promise(function (resolve) {
    return setTimeout(function () {
      return resolve();
    }, ms);
  });
};

var loop = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(f, max, stop, i) {
    var r;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return f();

          case 2:
            r = _context.sent;

            if (!(stop(r) || i >= max)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", r);

          case 7:
            _context.next = 9;
            return wait(10000);

          case 9:
            return _context.abrupt("return", loop(f, max, stop, i + 1));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function loop(_x23, _x24, _x25, _x26) {
    return _ref.apply(this, arguments);
  };
}();

function checkSubscription(_x27, _x28, _x29) {
  return _checkSubscription.apply(this, arguments);
} // {"success":true,"uid":"*5QADM","shortcode":"1901","keyword":"TIPS"}%  
// curl "http://w1.mozzi.com/spa-api/?country=gh&device=smart&slug=18plus-oc2sms&action=oc2sms"


function _checkSubscription() {
  _checkSubscription = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(window, maybeConfig, strategy) {
    var config, host, rockmanId, isDMB, newHost, check, checkResult, error;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            config = strategy ? _objectSpread({}, strategy.flowConfig) : _objectSpread({}, getConfig(), maybeConfig || {});
            host = config.host;
            rockmanId = window.pac_analytics.visitor.rockmanId;
            isDMB = window.pac_analytics.visitor.xaid != null && window.pac_analytics.visitor.xaid.toLowerCase().indexOf("dmb") != -1 ? true : false;
            newHost = isDMB ? "de.tallymans.com" : host;

            check = function check() {
              return fetch("https://".concat(newHost, "/tallyman/v1/?action=check-subscription&rockman_id=").concat(rockmanId)).then(function (x) {
                return x.json();
              });
            };

            _context7.next = 8;
            return loop(check, 60, function (r) {
              return r.success;
            }, 0);

          case 8:
            checkResult = _context7.sent;

            if (!(true === checkResult.success)) {
              _context7.next = 14;
              break;
            }

            window.location.href = checkResult.product_url;
            return _context7.abrupt("return", checkResult.product_url || null);

          case 14:
            error = new Error("SubscriptionFailed".concat(":\n", checkResult.message));
            error['type'] = "SubscriptionFailed";
            throw error;

          case 17:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _checkSubscription.apply(this, arguments);
}